import angular from 'angular';
import gridHeight from '../core/shared-service/grid-utils';
import Referential from '../referentials/Referential.data';

class listReferentialsCommunityCtrl {
    /*  @ngInject */

    constructor($state, CommunitySvc, $stateParams, logger, AuthSvc) {
        this.$state = $state
        this.$communitySvc = CommunitySvc
        this.$stateParams = $stateParams
        this.logger = logger
        this.authSvc = AuthSvc
    }

    $onInit() {
        this.displayLoading = true;
        this.querySearchCriteria = {
            model: true,
            control: true,
            clientCode: this.$stateParams.eid
        }
        this.searchPromise = this.$communitySvc.getAllReferentialsOfCommunity(this.querySearchCriteria);
        this.searchPromise.then(data => {
            let referentials = this.buildReferentialList(data.data);
            this.sections = referentials;
            this.oldSections = angular.copy(referentials);
            if (this.sections.length > 0) {
                if (this.sections[0].id) {
                    this.mode = 'success.update_all';
                } else {
                    this.mode = 'success.create_all';
                }
            } else {
                this.noResult = true;
            }
        }).catch(error => {
            this._onError(error);
            this.noResult = true;
        }).finally(() => {
            this.displayLoading = false;
        })
        this.isAuthorisedToEdit = this.authSvc.isAuthorized('CONFIGURATOR');
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }
    goBack() {
        this.$state.go('community.list.main');
    }
    save() {
        this.displayLoading = true;
        if (this.getchangedRefs().length != 0) {
            this.savePromise = this.$communitySvc.saveAllReferentials(this.querySearchCriteria, this.getchangedRefs());
            this.savePromise.then(data => {
                let referentials = this.buildReferentialList(data.data);
                this.sections = referentials;
                this.oldSections = angular.copy(referentials);
                this._onSaveSuccess(this.mode);
            })
                .catch(error => {
                    this._onError(error)
                })
                .finally(() => {
                    this.displayLoading = false;
                })
        } else {
            this._onSaveSuccess(this.mode);
            this.displayLoading = false;
        }
    }

    _onSaveSuccess(message /*:string*/) {
        this.logger.success(message, null, null, { entityName: 'Référentiels ' });
    }
    getchangedRefs() {
        let changedRef = [];
        for (let i = 0; i < this.oldSections.length; i++) {
            if (!this.isAttributeEquls(this.oldSections[i].attributs, this.sections[i].attributs)) {
                changedRef.push(this.sections[i]);
            }
        }
        return changedRef;
    }
    buildReferentialList(referentialDtos) {
        return (referentialDtos && referentialDtos.length > 0) ? referentialDtos.map(element => new Referential(element, 'COMMUNITY', this.querySearchCriteria.clientCode)) :
            [];
    }
    isAttributeEquls(oldAttrsSection, newAttrsSection) {
        let isChangedAttrs = true;
        for (let i = 0; i < oldAttrsSection.length; i++) {
            if (oldAttrsSection[i].display != newAttrsSection[i].display
                || oldAttrsSection[i].filter != newAttrsSection[i].filter
                || oldAttrsSection[i].order != newAttrsSection[i].order) {
                isChangedAttrs = false;
                break;
            }
        }
        return isChangedAttrs;
    }
    _onError(error) {
        if (error.statusText && error.statusText !== '') {
            this.logger.error(error.statusText);
        } else {
            this.logger.error('Une erreur est survenue');
        }
    }

}

angular.module('app.community').component('listReferentialsCommunity', {
    templateUrl: require('./list-referentials-community.html'),
    controller: listReferentialsCommunityCtrl,
    bindings: {}
});
